import "./index.scss";
import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import IGFly from "../../assets/img/Featured/fly-tap-pay-tall.png";
import IGOnDemand from "../../assets/img/Featured/app-ondemand-drinks.png";
import IGQuickPay from "../../assets/img/Featured/app-qr-quickpay-tall.png";
import IGSmartMenu from "../../assets/img/Featured/app-order-menu.png";
import Reserve from "../../assets/img/Featured/app-reserve-theatre.png";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
const TheatrePage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash theatrePage">
            <div className="background" />
            <Header />
            <div className="page-header">Theatre</div>
            <div className="text-blocks">
                <div className="std-text">
                    Ensure your patrons don't miss a minute of the 
                    show with self-service ordering directly from their 
                    seat. Individual QR codes identify each seat 
                    when ordering, so the servers know exactly 
                    where to deliver their orders without any 
                    interruptions. Or enable servers to take orders 
                    and accept payment wherever the patron is with 
                    mobile all-in-one devices.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Theatre", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={IGFly} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Theatre", "IG OnDemand");
                    addFlow("IG On Demand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Theatre", "IG Quick Pay");
                    addFlow("IG Quick Pay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Quick Pay
                    </div>
                    <img src={IGQuickPay} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Theatre", "IG Smart Menu");
                    addFlow("IG Smart Menu");
                    navigate("/solutions/ig-smart-menu")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Smart Menu
                    </div>
                    <img src={IGSmartMenu} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Theatre", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={Reserve} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default TheatrePage;